import { useState } from 'react';
import { C, t } from './dashboardConstants';
import { normalizeScheduleColor } from '../../../../shared/schedule/scheduleColors';

const MONTHS = ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'];
const DAYS = ['일','월','화','수','목','금','토'];

function buildMonthCells(year, month) {
  const firstDay = new Date(year, month, 1).getDay();
  const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();
  const daysInPrevMonth = new Date(year, month, 0).getDate();
  const cells = [];

  for (let i = firstDay - 1; i >= 0; i -= 1) {
    cells.push({
      year: month === 0 ? year - 1 : year,
      month: month === 0 ? 11 : month - 1,
      day: daysInPrevMonth - i,
      isOutsideMonth: true,
    });
  }

  for (let day = 1; day <= daysInCurrentMonth; day += 1) {
    cells.push({ year, month, day, isOutsideMonth: false });
  }

  let nextDay = 1;
  while (cells.length % 7 !== 0 || cells.length < 35) {
    cells.push({
      year: month === 11 ? year + 1 : year,
      month: month === 11 ? 0 : month + 1,
      day: nextDay,
      isOutsideMonth: true,
    });
    nextDay += 1;
  }

  return cells;
}

function MiniCalendar({ markedDates = [], circledDates = [], onMonthChange, onDateClick }) {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth());

  const todayYear = now.getFullYear();
  const todayMonth = now.getMonth();
  const todayDate = now.getDate();

  const cells = buildMonthCells(year, month);

  const toDay = (val) => {
    if (val && typeof val === 'object' && !(val instanceof Date)) {
      const source = val.date || val.startAt || val.scheduledAt || val.eventDate || val.value;
      const parts = String(source).slice(0, 10).split('-');
      return { y: Number(parts[0]), m: Number(parts[1]) - 1, d: Number(parts[2]) };
    }
    if (val instanceof Date) return { y: val.getFullYear(), m: val.getMonth(), d: val.getDate() };
    const parts = String(val).split('-');
    return { y: Number(parts[0]), m: Number(parts[1]) - 1, d: Number(parts[2]) };
  };

  const getMarkedItem = (targetYear, targetMonth, targetDay) => markedDates.find((v) => {
    const p = toDay(v);
    return p.y === targetYear && p.m === targetMonth && p.d === targetDay;
  });
  const isDark = (targetYear, targetMonth, targetDay) => Boolean(getMarkedItem(targetYear, targetMonth, targetDay));
  const isCircle = (targetYear, targetMonth, targetDay) => circledDates.some(v => { const p = toDay(v); return p.y === targetYear && p.m === targetMonth && p.d === targetDay; });
  const isToday = (targetYear, targetMonth, targetDay) => targetYear === todayYear && targetMonth === todayMonth && targetDay === todayDate;

  const changeMonth = (newYear, newMonth) => {
    setYear(newYear);
    setMonth(newMonth);
    if (onMonthChange) onMonthChange(newYear, newMonth);
  };

  const prev = () => {
    if (month === 0) changeMonth(year - 1, 11);
    else changeMonth(year, month - 1);
  };
  const next = () => {
    if (month === 11) changeMonth(year + 1, 0);
    else changeMonth(year, month + 1);
  };

  return (
    <div style={{ flex: 1, minWidth: '220px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
        <button onClick={prev} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', fontSize: '16px', color: C.bk }}>‹</button>
        <span style={t('16px', 600, C.bk)}>{year}년 {MONTHS[month]}</span>
        <button onClick={next} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', fontSize: '16px', color: C.bk }}>›</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px', textAlign: 'center' }}>
        {DAYS.map(d => <div key={d} style={t('11px', 500, C.g400, { padding: '4px 0' })}>{d}</div>)}
        {cells.map((cell, i) => {
          const markedItem = getMarkedItem(cell.year, cell.month, cell.day);
          const dark = isDark(cell.year, cell.month, cell.day);
          const today = isToday(cell.year, cell.month, cell.day);
          const circle = isCircle(cell.year, cell.month, cell.day);
          const markedColor = normalizeScheduleColor(markedItem?.color || markedItem?.eventColor);
          const bg = today ? '#FFD92B' : 'transparent';
          const border = (!today && circle) ? `1px solid ${C.bk}` : 'none';
          const color = cell.isOutsideMonth ? C.g300 : C.bk;
          return (
            <div
              key={`${cell.year}-${cell.month}-${cell.day}-${i}`}
              onClick={() => onDateClick?.(new Date(cell.year, cell.month, cell.day), markedDates.filter((v) => {
                const p = toDay(v);
                return p.y === cell.year && p.m === cell.month && p.d === cell.day;
              }))}
              style={{ width: '28px', height: '32px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', paddingTop: '5px', margin: '1px auto', borderRadius: '14px', background: bg, border, cursor: 'pointer', gap: '3px', boxSizing: 'border-box' }}
            >
              <span style={t('12px', 500, color)}>{cell.day}</span>
              {dark && <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: markedColor, display: 'block' }} />}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MiniCalendar;
